<template>
  <div class="app-container">
    <div class="flex_center_around bg-fff top_handle marginTop10">
      <van-button type="info"
                  size="mini"
                  @click="getOther('before')">上一月</van-button>
      <span class="fontSize14"
            @click="showCalendar = true">{{showDay }}</span>
      <van-calendar v-model="showCalendar"
                    :min-date="new Date('2001-01-01')"
                    :max-date="new Date()"
                    :default-date="new Date(currentDay)"
                    @confirm="onConfirm" />
      <van-button type="info"
                  size="mini"
                  @click="getOther('next')">下一月</van-button>
    </div>
    <div class="content">
      <van-tabs v-model="currentTab">
        <div class="flex_center fontSize12 totalTitle fontWeight">
          <span>统计周期内：全部</span>
          <span>{{ attendanceList[0].list.length }}天</span>
          <span>，满勤{{  attendanceList[1].list.length }}天</span>
          <span>，缺勤{{  attendanceList[2].list.length }}天</span>
          <span>，未出勤{{  attendanceList[3].list.length }}天</span>
        </div>
        <van-tab :title="item.title"
                 v-for="(item,index) in attendanceList"
                 :name="item.name">
          <div v-if="item.list.length > 0">
            <div class="dayItem"
                 v-for="(_item,_index) in item.list"
                 :class="{'marginTop10' : _index !== 0}">
              <div :class="'flagTitle'+ _item.attend"
                   class="flagTitle flex_center_between">
                <div class="flex_center">
                  <span class="round"></span>
                  <span>{{ _item.date }}</span>
                </div>
                <div class="attendName">{{ _item.attendName }}</div>
              </div>
              <div class="detail fontSize12">
                <div class="flex_center_between marginTop15"
                     v-for="(cq_item,cq_index) in _item.heatList">
                  <span style="width: 40%">{{cq_item.periodName}}：{{ cq_item.cqTime ? cq_item.cqTime : '--'}}</span>
                  <span class="animalHeat"
                        style="width: 40%"
                        :class="{'fontColorRed' : cq_item.cqAnimalHeat > 37.3}">体温：{{cq_item.cqAnimalHeat ? cq_item.cqAnimalHeat : '--'}}</span>
                  <span class="detail_btn text_r"
                        :class="{'hidden': !cq_item.cqTime}"
                        @click="getDetail(cq_item)">查看</span>
                </div>

              </div>
            </div>
          </div>
          <div v-else
               class="notResult">
            暂无数据
          </div>
        </van-tab>
      </van-tabs>
      <van-dialog v-model="showDlg"
                  title="考勤详情">
        <div class="flex_center_center ">
          <div class="fontSize14 padding20">
            <div class="flex_center_center">
              <img :src="'manage/' + currentRow.photoPath"
                   style="width: 100px;height:120px"
                   alt="">
            </div>
            <div class="marginTop10">
              姓名：{{currentRow.displayName}}
            </div>
            <div class="marginTop10">
              班级：{{currentRow.branchName}}
            </div>
            <div class="marginTop10">
              位置：{{currentRow.devPlace}}
            </div>
            <div class="marginTop10">
              考勤时段：{{currentRow.periodName}}
            </div>
            <div class="marginTop10">
              考勤时间：{{currentRow.date + ' ' + currentRow.cqTime}}
            </div>
            <div class="marginTop10">
              体温：{{currentRow.cqAnimalHeat ? currentRow.cqAnimalHeat : '--'}}
            </div>
          </div>
        </div>

      </van-dialog>
      <loading :loading="isLoading"></loading>
    </div>
    <Footer page="index"
            :active="activeFooterTab"></Footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import loading from '@/components/loading'
import Footer from '@/components/Footer'
import { parseTime, getBeforeMonth, getNextMonth, getLastMonthDay, compareTime } from '@/utils'
import { getUserShiftPeriodList, getEmployAttendanceList } from '@/api'
export default {
  components: {
    Footer,
    loading
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  data () {
    return {
      activeFooterTab: 0,
      isLoading: false,
      startDay: '',
      currentDay: '',
      showDay: '',
      attendanceList: [
        { title: '全部', name: 'all', list: [] },
        { title: '满勤', name: 'full', list: [] },
        { title: '缺勤', name: 'absence', list: [] },
        { title: '未出勤', name: 'live', list: [] },
      ],
      currentTab: 'all',
      periodList: [],
      showCalendar: false,
      baseUrl: '',
      currentRow: {},
      showDlg: false
    }
  },
  created () {
    // 默认获取当前时间到当前月的1号
    this.currentDay = parseTime(new Date(), '{y}-{m}-{d}')
    this.startDay = parseTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1), '{y}-{m}-{d}')
    this.showDay = this.startDay.substring(5) + ' - ' + this.currentDay.substring('5')
    //  this.baseUrl = process.env.VUE_APP_API + '/'
    this.getUserShiftPeriodList()
  },
  methods: {
    getUserShiftPeriodList () {
      this.attendanceList = [
        { title: '全部', name: 'all', list: [] },
        { title: '满勤', name: 'full', list: [] },
        { title: '缺勤', name: 'absence', list: [] },
        { title: '未出勤', name: 'leave', list: [] }
      ]
      this.periodList = []
      getUserShiftPeriodList({
        date: this.currentDay,
        employId: this.userInfo.code
      }).then(res => {
        if (res.code === 200) {
          this.periodList = res.data
          this.getEmployAttendanceList()
        } else {
          console.log(111)
        }
      })
    },
    // 获取上一个月下一个月
    getOther (type) {
      if (type === 'before') {
        const newDay = getBeforeMonth(this.startDay)
        this.startDay = newDay.start
        this.currentDay = newDay.end
        this.showDay = this.startDay.substring(5) + ' - ' + this.currentDay.substring('5')
        this.getUserShiftPeriodList()
      } else {
        // 如果已是当前月 则不允许再下一个月
        const newDay = getNextMonth(this.startDay)
        if (new Date().getMonth() + 1 === Number(newDay.start.split('-')[1]) - 1) {
          this.$Toast('暂不支持查看下个月的考勤数据！')
          return
        }
        this.startDay = newDay.start
        if (new Date() > new Date(newDay.end)) {
          this.currentDay = newDay.end
        } else {
          this.currentDay = parseTime(new Date(), '{y}-{m}-{d}')
        }
        this.showDay = this.startDay.substring(5) + ' - ' + this.currentDay.substring('5')
        this.getUserShiftPeriodList()
      }
    },
    onConfirm (val) {
      this.startDay = parseTime(new Date(new Date(val).getFullYear(), new Date(val).getMonth(), 1), '{y}-{m}-{d}')
      if (new Date(parseTime(new Date(val), '{y}-{m}-{d}')) >= new Date(parseTime(new Date(), '{y}-{m}-{d}'))) {
        this.currentDay = parseTime(new Date(), '{y}-{m}-{d}')
      } else {
        this.currentDay = getLastMonthDay(val)
      }
      this.showCalendar = false
      this.showDay = this.startDay.substring(5) + ' - ' + this.currentDay.substring('5')
      this.getUserShiftPeriodList()
    },
    // 获取我的考勤
    getEmployAttendanceList () {
      // 获取当月所有日期
      const year = this.startDay.split('-')[0]
      const month = this.startDay.split('-')[1]
      const start = Number(this.startDay.substring(8))
      const end = Number(this.currentDay.substring(8))
      const allDay = []
      for (let i = start; i <= end; i++) {
        allDay.push({
          date: parseTime(new Date(year + '-' + month + '-' + (i < 10 ? '0' + i : i)), '{y}-{m}-{d} {a}'),
          dayOfMonth: i,
          heatList: []
        })
      }
      this.isLoading = true
      getEmployAttendanceList({
        beginDate: this.startDay,
        endDate: this.currentDay,
        employId: this.userInfo.code
      }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            allDay.forEach((_item, _index) => {
              if (item.dayOfMonth === _item.dayOfMonth) {
                _item.heatList.push(item)
              }
              this.periodList.forEach(per_item => {
                _item.heatList.forEach(heat_item => {
                  if (compareTime(per_item.periodBeginTime + ':00', heat_item.cqTime) && compareTime(heat_item.cqTime, per_item.periodEndTime + ':00')) {
                    heat_item.periodName = per_item.periodName
                    heat_item.periodBeginTime = per_item.periodBeginTime
                    heat_item.periodEndTime = per_item.periodEndTime
                  }
                })
              })
            })
          })
          allDay.forEach(item => {
            if (item.heatList.length == 0) {
              item.heatList = JSON.parse(JSON.stringify(this.periodList))
            } else if (item.heatList.length < this.periodList.length) {
              item.tempHeatList = JSON.parse(JSON.stringify(this.periodList))
              item.tempHeatList.forEach(temp_item => {
                item.heatList.forEach(heat_item => {
                  if (temp_item.periodName == heat_item.periodName) {
                    temp_item.cqAnimalHeat = heat_item.cqAnimalHeat
                    temp_item.date = heat_item.date
                    temp_item.branchName = heat_item.branchName
                    temp_item.cqTime = heat_item.cqTime
                    temp_item.devPlace = heat_item.devPlace
                    temp_item.displayName = heat_item.displayName
                    temp_item.photoPath = heat_item.photoPath
                  }
                })
              })
              item.heatList = JSON.parse(JSON.stringify(item.tempHeatList))
              // item.heatList = JSON.parse(JSON.stringify(item.tempHeatList))
            }
            if (item.heatList.filter(_item => {
              return _item.cqAnimalHeat != '' && _item.cqAnimalHeat
            }).length == 0) {
              this.attendanceList[3].list.push(item)

              item.attend = 'leave'
              item.attendName = '未出勤'
            } else {
              if (item.heatList.every(_item => {
                return _item.cqAnimalHeat != '' && _item.cqAnimalHeat
              })) {
                this.attendanceList[1].list.push(item)

                item.attend = 'full'
                item.attendName = '满勤'
              } else {
                this.attendanceList[2].list.push(item)

                item.attend = 'absence'
                item.attendName = '缺勤'
              }
            }
            this.attendanceList[0].list.push(item)
          })
          this.attendanceList[0].list = this.attendanceList[0].list.reverse()
          this.attendanceList[2].list = this.attendanceList[2].list.reverse()
          this.attendanceList[1].list = this.attendanceList[1].list.reverse()
          this.attendanceList[3].list = this.attendanceList[3].list.reverse()
          this.isLoading = false
        } else {
          this.isLoading = false
        }
      })
    },
    // 查看详情
    getDetail (cq_item) {
      this.currentRow = cq_item
      this.showDlg = true
    }
  }
}
</script>

<style lang="less" scoped>
.app-container {
  ::v-deep .van-button--info {
    background-color: #05b6fc;
    border-color: #05b6fc;
  }
  .notResult {
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
  }
  .detail_btn {
    color: #0487bb;
    font-weight: bold;
  }
  .content {
    height: calc(100% - 92px);
    padding-bottom: 10px;
    background: rgb(245, 245, 245);
    .totalTitle {
      line-height: 40px;
    }
    ::v-deep .van-tabs {
      height: 100%;
    }
    ::v-deep .van-tab--active {
      color: #1ac388;
    }
    ::v-deep .van-tabs__line {
      background-color: #1ac388;
    }
    ::v-deep .van-tabs__content {
      padding: 0 10px;
      background-color: #f5f5f5;
      height: calc(100% - 44px);
      .van-tab__pane {
        height: calc(100% - 40px);
        overflow-y: auto;
        .dayItem {
          padding: 10px;
          background-color: #fff;
          border-radius: 10px;
          .flagTitle {
            font-size: 14px;
            font-weight: bold;
            .round {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              margin-right: 5px;
            }
          }
          .detail {
            padding: 0 0 0 20px;
            .animalHeat {
              width: 65px;
            }
          }
          .flagTitlefull {
            .round {
              background-color: #1ac388;
            }
            .attendName {
              color: #1ac388;
            }
          }
          .flagTitleabsence {
            .round {
              background-color: #c36c1a;
            }
            .attendName {
              color: #c36c1a;
            }
          }
          .flagTitleleave {
            .round {
              background-color: #c32e1a;
            }
            .attendName {
              color: #c32e1a;
            }
          }
        }
      }
    }
  }
}
</style>